import {
  axios,
  config
} from '../api'
// import store from '../store'
let contract = {}

// 获取修改合同信息
contract.getEditdto = (_ID) => {
  return axios('post', config.API_URL + '/api/Contract/GetEditdto',{}, {
    ID: _ID
  })
}

// 根据费用获取合同 to do这个是拿来干啥的
contract.getContractByPayID = (_payID) => {
  return axios('post', config.API_URL + '/api/Contract/GetContractByPayID',{}, {
    payID: _payID
  })
}

// 查看合同结清信息
contract.getContractEndDto = (_ID) => {
  return axios('post', config.API_URL + '/api/Contract/GetContractEndDto',{}, {
    ID: _ID
  })
}

// 修改合同状态
// contract.setState = (_ID,_state) => {
//   return axios('post', config.API_URL + '/api/Contract/SetState',{}, {
//     ID: _ID,
//     state:_state,
//     date:''
//   })
// }
contract.setState = {
  data: {
    ID: 0,
    state:'' ,
    date:''
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Contract/SetState',{}, _data)
  }
}

contract.add = {
  data: {
    PriceDetailList: [
      {
        DetailList: [
          {
            Type: "商铺租金",
            MonthPrice: 0,
            MeterPrice: 0
          },
          {
            Type: "土地租金",
            MonthPrice: 0,
            MeterPrice: 0
          },
          {
            Type: "车位租金",
            MonthPrice: 0,
            MeterPrice: 0
          }
        ],
        BeginDate: "",
        EndDate: "",
        YearPercent: 0
      }
    ],
    FileList: [],
    ContractHistoryList:[],
    SerialNum: "", //合同编号
    Name: "",
    ShopIDs: "", //逗号分隔的商铺id
    CusID: 0,
    State: "",
    APartyName: "成都长城实业集团有限公司",
    APartyBankName: "招商银行股份有限公司成都红牌楼支行",
    APartyBankNum: "128904240810888",
    BPartyName: "",
    BPartyNum: "",
    Address: "",
    Area: 0,
    BusinessScope: "", //经验范围
    TimeUnit: 0, // 期限xx年，年月未定，直接叫这么名字
    BeginDate: "",
    EndDate: "",
    AreaRent: 0, // 第二个面积
    FirstQuarterRent: 0,
    AgreeDeposit: 0, // 履约押金
    WaterDeposit: 0, // 水电押金
    CycleType:'季付',
    Notes: "", // 备注
    SignDate: "", // 签订日期，精确到日
    Agent: "", //经办人
    PrevSerialNum: "" //续租上一个合同
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Contract/Add', _data)
  }
}

contract.edit = {
  data: {
    PriceDetailList: [
      {
        DetailList: [], // 默认全部写出来
        SerialNum: "",
        ContractID: "",
        BeginDate: "",
        EndDate: "",
        YearPercent: 0
      }
    ],
    FileList: [],
    ContractHistoryList:[],
    SerialNum: "", //合同编号
    Name: "",
    ShopIDs: "", //逗号分隔的商铺id
    CusID: 0,
    State: "",
    APartyName: "成都长城实业集团有限公司",
    APartyBankName: "招商银行股份有限公司成都红牌楼支行",
    APartyBankNum: "128904240810888",
    BPartyName: "",
    BPartyNum: "",
    Address: "",
    Area: 0,
    BusinessScope: "", //经验范围
    TimeUnit: 0, // 期限xx年，年月未定，直接叫这么名字
    BeginDate: "",
    EndDate: "",
    AreaRent: 0, // 第二个面积
    FirstQuarterRent: 0,
    AgreeDeposit: 0, // 履约押金
    WaterDeposit: 0, // 水电押金
    CycleType:'',
    Notes: "", // 备注
    SignDate: "", // 签订日期，精确到日
    Agent: "", //经办人
    PrevSerialNum: "" //续租上一个合同
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Contract/Edit', _data)
  }
}

contract.del = (_idList) => {
  return axios('post', config.API_URL + '/api/Contract/Del', {},{
    idList: _idList //这是一个数组
  })
}

// 通过商铺ID获取合同，返回的是当前商铺正在出租的合同
contract.getShopContractList = (_shopID) => {
  return axios('post', config.API_URL + '/api/Contract/GetShopContractList',{},{
    shopID: _shopID
  })
}
contract.getList = {
  data: {
    PageIndex: 1,
    PageSize: 10,
    Orderby:null,
    CondList: [
      {
        Key: "",
        Operator: "",
        Value: ""
      }
    ]
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Contract/GetList', _data)
  }
}

contract.export = {
  data: {
    PageIndex: 1,
    PageSize: 10,
    CondList: [
      {
        Key: "",
        Operator: "",
        Value: ""
      }
    ]
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Contract/ExportList',_data,{},1)
  }
}

contract.getContractAccount = (_ID) => {
  return axios('post', config.API_URL + '/api/Contract/GetContractAccount', {},{
    ID: _ID
  })
}

contract.getContractHistoryList = {
  data: {
    PageIndex: 1,
    PageSize: 10,
    CondList: [
      {
        Key: "",
        Operator: "",
        Value: ""
      }
    ]
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Contract/GetContractHistoryList', _data)
  }
}
export default contract


